module.exports = __webpack_public_path__ + "static/media/user.422b0839.svg";